import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "store";
import moment from "moment";
import smoothscroll from "smoothscroll-polyfill";
import { ConfigProvider } from "antd";
import VConsole from "vconsole";
import getQueryString from "libs/getQueryString";
import ErrorBoundary from "libs/ErrorBoundary";

import "antd/dist/antd.less";
import "./styles/index.scss";
import zhCN from "antd/lib/locale/zh_CN";

import IntlWrap from "components/IntlWrap";

const consoleSecret = "console_secret";

if (
  ["test.ssc.hrtps.com", "dev.ssc.hrtps.com"].includes(
    window.location.host
  ) ||
  getQueryString("console") === consoleSecret
) {
  new VConsole({ maxLogNumber: 1000 });
}

smoothscroll.polyfill();
moment.locale("zh-cn");

// alert(`default url: ${window.location.href}`);

ReactDOM.render(
  // @ts-ignore
  <ErrorBoundary>
    <Provider store={store}>
      <IntlWrap>
        <ConfigProvider locale={zhCN}>
          <App />
        </ConfigProvider>
      </IntlWrap>
    </Provider>
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
